import React from "react";
import CompanyUpiPanel from "@/components/CompanyUpiPanel";

export default function CompanyUpis() {
    return (
        <div data-testid="company-upis-page" className="space-y-5">
            <div>
                <h1 className="font-display text-2xl font-bold text-slate-900">Company UPI IDs</h1>
                <p className="mt-1 text-sm text-slate-500">
                    Manage the UPI IDs your business receives payments on. Slips paid to any UPI
                    NOT in this list are blocked from verification until you add or override.
                    Give each row a meaningful <b>Belongs to</b> label (e.g. Goodluck, Kundra
                    Agencies) so it shows up correctly in the Payments-by-UPI report.
                </p>
            </div>
            <CompanyUpiPanel />
        </div>
    );
}
